import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { useRoute } from 'vue-router/composables';
import { useI18n } from '@/helpers/composables/useI18n';
import { useQuery } from '@/helpers/composables/useApollo';
import { useConstantStore, useLanguageStore } from '@/helpers/composables/useStores';

import { ObjectType, Platform, SportType } from '@/@types/graphql-types';
import { SportLocale } from '@/features/sports/types/enums';
import { SnowplowContext, SnowplowSportContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import {
	GetSportProvidersByShortNamesDocument,
	GetSportProvidersByShortNamesQuery,
	GetSportProvidersByShortNamesQueryVariables,
} from '@/features/sports/graphql/queries/GetSportProvidersByShortNames.query';
import { getOverviewUrlBySport } from '@/routing/sports';


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalSportsHeaderCard',
  props: {
    name: null,
    sportIcon: null,
    sport: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { name: string, sportIcon: string, sport: SportType, additionalContexts: SnowplowContext[] };



const route = useRoute();
const { tc } = useI18n();
const { country, webLocale } = useLanguageStore();
const { providersByShortName } = useConstantStore();

const queryVariables = computed<GetSportProvidersByShortNamesQueryVariables>(() => ({
	country: country.value,
	platform: Platform.Web,
}));

const { result } = useQuery<GetSportProvidersByShortNamesQuery, GetSportProvidersByShortNamesQueryVariables>(
	GetSportProvidersByShortNamesDocument,
	queryVariables,
	{
		enabled: route.name?.startsWith('app.home'),
	}
);

const sportProvidersByShortName = computed<string[]>(() =>
	(result.value?.packages || []).map(({ shortName }) => shortName)
);

const overviewFullPath = computed(() => getOverviewUrlBySport(props.sport, webLocale.value as SportLocale));

const overviewRoute = computed(() => ({
	name: 'app.sports.overview',
	path: overviewFullPath.value,
}));

const providers = computed(() => {
	const sportProviders = sportProvidersByShortName.value
		.map(name => providersByShortName.value[name])
		.filter(provider => provider != null);

	return sportProviders;
});

const sportName = computed(() => tc(`WEBAPP_GLOBAL_${props.sport}`));

function handleSeeAllClick() {
	const sportContext = new SnowplowSportContext(props.sport, ObjectType.Sport);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'sport_clicked',
			property: 'card-v2',
		},
		[sportContext, ...props.additionalContexts]
	);
}

return { __sfc: true,props, route, tc, country, webLocale, providersByShortName, queryVariables, result, sportProvidersByShortName, overviewFullPath, overviewRoute, providers, sportName, handleSeeAllClick, HiddenHorizontalScrollbar, ProviderIcon }
}

})